import { HandlerShape } from "../../types/handlerShape";
import { Handler } from "./Handler";
import { useRoot } from "../../contexts/Root";
import { useProgress } from "../../contexts/Progress";
import { useSeekBar } from "../../contexts/SeekBar";

export const ProgressHandler = () => {
  const {
    clippingEnabled,
    clipRange,
    theme: { emphasis },
  } = useRoot();

  const { offset } = useProgress();
  const { isPointerDown, isPointerInside } = useSeekBar();

  const showClipRange =
    clippingEnabled !== undefined && clippingEnabled && clipRange !== undefined;

  const scale =
    (isPointerDown && 4) || ((showClipRange || isPointerInside) && 3) || 1;

  const show = isPointerDown || isPointerInside || showClipRange;

  return (
    <Handler
      shape={HandlerShape.circle}
      color={emphasis}
      offset={offset}
      show={show}
      zIndex={6}
      scale={scale}
    />
  );
};
